import { Controller } from "@hotwired/stimulus";
import { isStringTrue } from "../../utils/misc";

const PROCESSING_TIMEOUT = 30000;

export default class extends Controller {
  static targets = ["loader", "loaderText", "invoice", "processingErrorMessage"];
  static values = { canReceiveOcrProcessedData: true };

  connect() {
    if (!isStringTrue(this.element.dataset.usingOcr)) {
      this._displayEmptyForm();
      return;
    }

    this._waitForOcrResponse();
  }

  _waitForOcrResponse() {
    const timers = this._setTimers();
    document.addEventListener("accountingDocument:ocrProcessed", (e) => {
      if (
        this.canReceiveOcrProcessedDataValue &&
        e.detail.accounting_document_id === this.currentAccountingDocumentId
      ) {
        timers.forEach((timer) => clearTimeout(timer));
        this.canReceiveOcrProcessedDataValue = false;
        this._toggleForm();

        this.element.dispatchEvent(new CustomEvent("accountingDocument:processedFormReady", { detail: e.detail }));
      }
    });
  }

  get currentAccountingDocumentId() {
    return parseInt(this.element.dataset.accountingDocumentId);
  }

  _setTimers() {
    const firstTimer = setTimeout(() => {
      this.loaderTextTarget.innerText = "Veuillez patienter, nous scannons votre facture";
    }, 3000);

    const secondTimer = setTimeout(() => {
      this.loaderTextTarget.innerText = "Désolé, cela prend un peu plus de temps que prévu";
    }, 10000);

    const thirdTimer = setTimeout(() => {
      this._ocrProcessingTimedOut();
    }, PROCESSING_TIMEOUT);

    return [firstTimer, secondTimer, thirdTimer];
  }

  _ocrProcessingTimedOut() {
    this.canReceiveOcrProcessedDataValue = false;
    this._displayEmptyForm();

    this.processingErrorMessageTarget.classList.remove("hidden");
  }

  _displayEmptyForm() {
    this._toggleForm();

    this.element.dispatchEvent(new CustomEvent("accountingDocument:processedFormReady", { detail: {} }));
  }

  _toggleForm() {
    this.loaderTarget.classList.add("hidden");
    this.invoiceTarget.classList.remove("hidden");
  }
}
